import React, { createContext, useState, useContext, useEffect } from 'react';
import apiService from '../services/ApiService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Check if user is logged in on mount
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('user_id');
        const userType = localStorage.getItem('user_type');

        if (token && userId && (userType === 'admin' || userType === 'superadmin')) {
            setIsAuthenticated(true);
            setUser({
                id: userId,
                type: userType,
                isSuperAdmin: userType === 'superadmin'
            });
            apiService.setToken(token);
        }
        setLoading(false);
    }, []);

    const login = (userData) => {
        localStorage.setItem('token', userData.token);
        localStorage.setItem('user_id', userData.user_id);
        localStorage.setItem('user_type', userData.user_type);

        apiService.setToken(userData.token);
        setUser({
            id: userData.user_id,
            type: userData.user_type,
            isSuperAdmin: userData.user_type === 'superadmin'
        });
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_type');

        apiService.setToken(null);
        setUser(null);
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
